import React, { useEffect, useState } from 'react';
import ImportDataGridView from '../../../../components/importdatagridview/ImportDataGridView';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, updateBatchImportFormData } from '../../BatchImportSlice';

export default function EditImportData(){

	const {batchImportFormData, formSettings, isStateFilingApplicable} = useSelector(state => state[componentKey])

	const dispatch = useDispatch();
	const [showImportDataGridView, setShowImportDataGridView] = useState(false);

	useEffect(() => {
		if (batchImportFormData.goToListingStep) {
			setShowImportDataGridView(true)
			dispatch(updateBatchImportFormData({goToListingStep: null}));
		}
	}, [batchImportFormData.goToListingStep]);

	return <>
		{
			showImportDataGridView && <ImportDataGridView
				isStateFilingApplicable={isStateFilingApplicable}
				filingForCorrected={batchImportFormData?.filingForCorrected ?? false}
				formSettings={formSettings}
				formName={batchImportFormData?.selectedForm?.FormId}
				formId={batchImportFormData?.selectedForm?.Id}
				taxYear={batchImportFormData?.selectedYear}
			/>
		}
	</>
}